/********************************************************************/
/*** Initially Implemeneted By Fahad Akbar(fahadakbar24@gmail.com) **/
/********************************************************************/

angular.module('app.directives.lexstepFooter',[]);


// WEBPACK FOOTER //
// ./scripts/shared/directives/footer/module.js